<template>
  <BaseNewForm>
    <template v-slot:header>
      {{ $t('qic_user_dob_header') }}
    </template>
    <div class="annual_calendar start_date moto_udob" >
      <DatePickerDesktop
        :showAlways="true"
        :value="date"
        @input="onInput"
        :max-date="maxDate"
        :min-date="minDate"
      />

      <div class="error-input-message" v-if="isError">
        {{$t('renew.select_birth_date.qid_mismatch_error')}}
      </div>
    </div>

    <BaseButton @click="onSubmit"/>
    <Reminder/>
  </BaseNewForm>
</template>

<script>
import { required, maxValue } from 'vuelidate/lib/validators'
import { DatePickerDesktop, wizardStepMixin, Reminder, BaseNewForm } from 'qic-components'
import { calculateAge, trackGtag } from '@/utils/useGtag'

export default {
  components: {
    DatePickerDesktop,
    Reminder,
    BaseNewForm
  },
  mixins: [
    wizardStepMixin
  ],
  name: 'MotorUserDob',
  data () {
    return {
      date: this.$store.state.motor.dateOfBirth ? new Date(this.$store.state.motor.dateOfBirth) : this.startDate(),
      isError: false
    }
  },
  computed: {
    isFormInvalid () {
      return this.$v.$invalid
    },
    maxDate () {
      const now = new Date()
      return new Date(now.getFullYear() - 18, now.getMonth(), now.getDate())
    },
    minDate () {
      const now = new Date()
      return new Date(now.getFullYear() - 70, now.getMonth(), now.getDate())
    }
  },
  methods: {
    onInput (date) {
      this.date = date
    },
    startDate () {
      const DEFAULT_BIRTHDAY_DATE = new Date(1990, 0, 1)

      const qid = this.$store.state.renew.userData.qid
      if (qid && qid.length > 2) {
        const centuryIndicator = qid.charAt(0)
        const yearInCentury = parseInt(qid.substring(1, 3))

        let fullYear
        if (centuryIndicator === '2') {
          fullYear = 1900 + yearInCentury
        } else if (centuryIndicator === '3') {
          fullYear = 2000 + yearInCentury
        } else {
          return DEFAULT_BIRTHDAY_DATE
        }

        return new Date(fullYear, 0, 1)
      }
      return DEFAULT_BIRTHDAY_DATE
    },
    validateBirthDateByQID () {
      const qid = this.$store.state.renew.userData.qid
      if (!this.date || !qid || qid.length < 3) {
        return true
      }

      const centuryDigit = parseInt(qid.charAt(0))
      const yearOfBirth = parseInt(qid.substring(1, 3))

      const century = (centuryDigit === 2) ? 1900 : (centuryDigit === 3) ? 2000 : 0
      if (!century) {
        return false
      }

      const fullYearOfBirth = century + yearOfBirth

      return this.date.getFullYear() === fullYearOfBirth
    },
    onSubmit () {
      this.$v.date.$touch()
      if (this.isFormInvalid) return

      this.isError = !this.validateBirthDateByQID()
      if (this.isError) {
        return
      }

      const dateOfBirth = new Date(
        this.date.getFullYear(),
        this.date.getMonth(),
        this.date.getDate()
      )

      trackGtag('selectBirthDate', {
        label: this.date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'numeric', year: 'numeric' }),
        age: calculateAge(dateOfBirth)
      })

      this.loadNextPage(
        this.$store.dispatch('setMotorDob', dateOfBirth)
          .then(() => {
            this.$emit('next')
          })
      )
    }
  },
  created () {
    if (this.$store.state.renew.policyInfo.driverDOB) this.$emit('next', { replace: true })
  },
  validations () {
    return {
      date: {
        required,
        maxValue: maxValue(new Date(this.maxDate.getFullYear(), this.maxDate.getMonth(), this.maxDate.getDate() + 1))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.error-input-message {
  color: #F94C27;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  margin: 0 24px;

  @media (max-width: 375px) {
    margin: 0;
  }
}
</style>
